import type { Layout } from "react-grid-layout"

export const spanTabLayoutLg: Record<string, Layout> = {
  MOTION_DETECTION: {
    w: 12,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "MOTION_DETECTION",
  },
  MOTION_INTENSITY: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "MOTION_INTENSITY",
  },
  CONDUCTOR_TEMPERATURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "CONDUCTOR_TEMPERATURE",
  },
  LAST_CONDUCTOR_TEMPERATURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 6,
    minH: 0,
    i: "LAST_CONDUCTOR_TEMPERATURE",
  },
  BENDING_AMPLITUDE: {
    w: 9,
    h: 3,
    x: 0,
    y: 9,
    minH: 0,
    i: "BENDING_AMPLITUDE",
  },
  MAX_BENDING_AMPLITUDE: {
    w: 3,
    h: 1.5,
    x: 9,
    y: 9,
    minH: 0,
    i: "MAX_BENDING_AMPLITUDE",
  },
  PERCENTAGE_ABOVE_BENDING_AMPLITUDE_LIMIT: {
    w: 3,
    h: 1.5,
    x: 9,
    y: 10.5,
    minH: 0,
    i: "PERCENTAGE_ABOVE_BENDING_AMPLITUDE_LIMIT",
  },
  CUMULATIVE_FATIGUE: {
    w: 9,
    h: 3,
    x: 0,
    y: 12,
    minH: 0,
    i: "CUMULATIVE_FATIGUE",
  },
  LAST_CUMULATIVE_FATIGUE: {
    w: 3,
    h: 3,
    x: 9,
    y: 12,
    minH: 0,
    i: "LAST_CUMULATIVE_FATIGUE",
  },
  ICE_ACCRETION_DETECTION: {
    w: 9,
    h: 3,
    x: 0,
    y: 15,
    minH: 0,
    i: "ICE_ACCRETION_DETECTION",
  },
  LAST_ICE_ACCRETION_DETECTION: {
    w: 3,
    h: 3,
    x: 9,
    y: 15,
    minH: 0,
    i: "LAST_ICE_ACCRETION_DETECTION",
  },
  TRANSVERSE_WIND_SPEED: {
    w: 9,
    h: 3,
    x: 0,
    y: 18,
    minH: 0,
    i: "TRANSVERSE_WIND_SPEED",
  },
  LAST_T_WIND_SPEED: {
    w: 3,
    h: 3,
    x: 9,
    y: 18,
    minH: 0,
    i: "LAST_T_WIND_SPEED",
  },
  SAG: {
    w: 9,
    h: 3,
    x: 0,
    y: 21,
    minH: 0,
    i: "SAG",
  },
  LAST_MAX_SAG: {
    w: 3,
    h: 1,
    x: 9,
    y: 21,
    minH: 0,
    i: "LAST_MAX_SAG",
  },
  LAST_LOWEST_POINT_SAG: {
    w: 3,
    h: 1,
    x: 9,
    y: 22,
    minH: 0,
    i: "LAST_LOWEST_POINT_SAG",
  },
  LAST_MIDPOINT_SAG: {
    w: 3,
    h: 1,
    x: 9,
    y: 23,
    minH: 0,
    i: "LAST_MIDPOINT_SAG",
  },
  CONDUCTOR_TENSION: {
    w: 9,
    h: 3,
    x: 0,
    y: 24,
    minH: 0,
    i: "CONDUCTOR_TENSION",
  },
  LAST_HORIZONTAL_TENSION: {
    w: 3,
    h: 1,
    x: 9,
    y: 24,
    minH: 0,
    i: "LAST_HORIZONTAL_TENSION",
  },
  LAST_TENSION_AT_LOWER_SUPPORT: {
    w: 3,
    h: 1,
    x: 9,
    y: 25,
    minH: 0,
    i: "LAST_TENSION_AT_LOWER_SUPPORT",
  },
  LAST_TENSION_AT_UPPER_SUPPORT: {
    w: 3,
    h: 1,
    x: 9,
    y: 26,
    minH: 0,
    i: "LAST_TENSION_AT_UPPER_SUPPORT",
  },
  CURRENT: {
    w: 9,
    h: 3,
    x: 0,
    y: 27,
    minH: 0,
    i: "CURRENT",
  },
  LAST_CURRENT: {
    w: 3,
    h: 3,
    x: 9,
    y: 27,
    minH: 0,
    i: "LAST_CURRENT",
  },
}

export const deviceTabLayoutLg: Record<string, Layout> = {
  BATTERY_STATUS: {
    w: 6,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "BATTERY_STATUS",
  },
  SIGNAL_LEVEL: {
    w: 6,
    h: 3,
    x: 6,
    y: 0,
    minH: 0,
    i: "SIGNAL_LEVEL",
  },
  BATTERY: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "BATTERY",
  },
}

export const deviceTowerTabLayoutLg: Record<string, Layout> = {
  AVERAGE_INCLINATION: {
    w: 12,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "AVERAGE_INCLINATION",
  },
  MOTION_DETECTION: {
    w: 12,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "MOTION_DETECTION",
  },
  MOTION_INTENSITY: {
    w: 12,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "MOTION_INTENSITY",
  },
}

export const wStationAmbientTabLayoutLg: Record<string, Layout> = {
  WEATHER_STATION_TEMPERATURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "WEATHER_STATION_TEMPERATURE",
  },
  LAST_WEATHER_STATION_TEMPERATURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 0,
    minH: 0,
    i: "LAST_WEATHER_STATION_TEMPERATURE",
  },
  WEATHER_STATION_HUMIDITY: {
    w: 9,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "WEATHER_STATION_HUMIDITY",
  },
  LAST_WEATHER_STATION_HUMIDITY: {
    w: 3,
    h: 3,
    x: 9,
    y: 3,
    minH: 0,
    i: "LAST_WEATHER_STATION_HUMIDITY",
  },
  WEATHER_STATION_PRESSURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "WEATHER_STATION_PRESSURE",
  },
  LAST_WEATHER_STATION_PRESSURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 6,
    minH: 0,
    i: "LAST_WEATHER_STATION_PRESSURE",
  },
  WEATHER_STATION_PRECIPITATION_INTENSITY: {
    w: 9,
    h: 3,
    x: 0,
    y: 9,
    minH: 0,
    i: "WEATHER_STATION_PRECIPITATION_INTENSITY",
  },
  LAST_WEATHER_STATION_PRECIPITATION_INTENSITY: {
    w: 3,
    h: 3,
    x: 9,
    y: 9,
    minH: 0,
    i: "LAST_WEATHER_STATION_PRECIPITATION_INTENSITY",
  },
  WEATHER_STATION_SOLAR_IRRADIANCE: {
    w: 9,
    h: 3,
    x: 0,
    y: 12,
    minH: 0,
    i: "WEATHER_STATION_SOLAR_IRRADIANCE",
  },
  LAST_WEATHER_STATION_SOLAR_IRRADIANCE: {
    w: 3,
    h: 3,
    x: 9,
    y: 12,
    minH: 0,
    i: "LAST_WEATHER_STATION_SOLAR_IRRADIANCE",
  },
  WEATHER_STATION_WIND_DIRECTION: {
    w: 9,
    h: 3,
    x: 0,
    y: 15,
    minH: 0,
    i: "WEATHER_STATION_WIND_DIRECTION",
  },
  LAST_WEATHER_STATION_WIND_DIRECTION: {
    w: 3,
    h: 3,
    x: 9,
    y: 15,
    minH: 0,
    i: "LAST_WEATHER_STATION_WIND_DIRECTION",
  },
  WEATHER_STATION_WIND_SPEED: {
    w: 9,
    h: 3,
    x: 0,
    y: 18,
    minH: 0,
    i: "WEATHER_STATION_WIND_SPEED",
  },
  LAST_WEATHER_STATION_WIND_SPEED: {
    w: 3,
    h: 3,
    x: 9,
    y: 18,
    minH: 0,
    i: "LAST_WEATHER_STATION_WIND_SPEED",
  },
}

// Weather-service (geohash) plots for the span device Ambient tab.
export const wServiceAmbientTabLayoutLg: Record<string, Layout> = {
  WEATHER_SERVICE_WIND_SPEED: {
    w: 9,
    h: 3,
    x: 0,
    y: 0,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_SPEED",
  },
  LAST_WEATHER_SERVICE_WIND_SPEED: {
    w: 3,
    h: 3,
    x: 9,
    y: 0,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_SPEED",
  },
  WEATHER_SERVICE_WIND_GUSTS: {
    w: 9,
    h: 3,
    x: 0,
    y: 3,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_GUSTS",
  },
  LAST_WEATHER_SERVICE_WIND_GUSTS: {
    w: 3,
    h: 3,
    x: 9,
    y: 3,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_GUSTS",
  },
  WEATHER_SERVICE_WIND_DIRECTION: {
    w: 9,
    h: 3,
    x: 0,
    y: 6,
    minH: 0,
    i: "WEATHER_SERVICE_WIND_DIRECTION",
  },
  LAST_WEATHER_SERVICE_WIND_DIRECTION: {
    w: 3,
    h: 3,
    x: 9,
    y: 6,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_WIND_DIRECTION",
  },
  WEATHER_SERVICE_TEMPERATURE: {
    w: 9,
    h: 3,
    x: 0,
    y: 9,
    minH: 0,
    i: "WEATHER_SERVICE_TEMPERATURE",
  },
  LAST_WEATHER_SERVICE_TEMPERATURE: {
    w: 3,
    h: 3,
    x: 9,
    y: 9,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_TEMPERATURE",
  },
  WEATHER_SERVICE_RELATIVE_HUMIDITY: {
    w: 9,
    h: 3,
    x: 0,
    y: 12,
    minH: 0,
    i: "WEATHER_SERVICE_RELATIVE_HUMIDITY",
  },
  LAST_WEATHER_SERVICE_RELATIVE_HUMIDITY: {
    w: 3,
    h: 3,
    x: 9,
    y: 12,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_RELATIVE_HUMIDITY",
  },
  WEATHER_SERVICE_PRECIPITATION: {
    w: 9,
    h: 3,
    x: 0,
    y: 15,
    minH: 0,
    i: "WEATHER_SERVICE_PRECIPITATION",
  },
  LAST_WEATHER_SERVICE_PRECIPITATION: {
    w: 3,
    h: 3,
    x: 9,
    y: 15,
    minH: 0,
    i: "LAST_WEATHER_SERVICE_PRECIPITATION",
  },
}
